

























import { Component, Prop, Vue } from "vue-property-decorator";
import { SecinfoKO } from "@/types";
import TrainBoxKO from "@/components/TrainBoxKO.vue";
import { UnyoList } from "@/apis/kostl/vehicles/@types";

@Component({
  components: {
    TrainBoxKO
  }
})
export default class LineSectionKO extends Vue {
  @Prop({ required: true })
  secinfo!: SecinfoKO;
  @Prop({ required: true })
  unyoList!: UnyoList;
}
